import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory,
} from 'react-router-dom';
import PrivateRoute from '../PrivateRoutes';
import Complete from '../Pages/stashfin-merchant/Complete';
import Dashboard from '../Pages/stashfin-merchant/Dashboard';
import Login from '../Pages/stashfin-merchant/Login/index';
import Rejected from '../Pages/stashfin-merchant/Rejected';
import Pending from '../Pages/stashfin-merchant/Pending';
import Received from '../Pages/stashfin-merchant/Received';
import Registration from '../Pages/stashfin-merchant/Registration';
import ProductDetails from '../Pages/stashfin-merchant/ProductDetails';
import PendingStatus from '../Pages/stashfin-merchant/PendingStatus';
import Reject from '../Pages/stashfin-merchant/Reject';
import AvailableOffers from '../Pages/stashfin-merchant/AvailableOffers/index';
import SorryPage from '../Pages/stashfin-merchant/Sorry/index';
import SucessPage from '../Pages/stashfin-merchant/Sucess/index';
import Congratulations from '../Pages/stashfin-merchant/Congratulations';
import CheckEligibility from '../Pages/stashfin-merchant/Eligibility';
import QrScanner from '../Pages/stashfin-merchant/QRScanner';
import DownPayment from '../Pages/stashfin-merchant/DownPayment';
import ImeiScreenCard from '../Pages/stashfin-merchant/ImeiNumber';
import OfferSummery from '../Pages/stashfin-merchant/OfferSummery';
import Header from '../Common/header';
import P2PRoutes from './StashKar/routes';
import { setAuthToken, setSource } from '../utils/localStorage';
import ScrollToTop from './StashKar/scrollToTop';

export default function Pages() {
  const redi_url = process.env.REACT_APP_BASE_REDIRECT_URL;
  const history = useHistory();
  const params = new URLSearchParams(window?.location?.search);
  const getParam = (key: string): any => {
    if (params) {
      if (key === 'landing_page') {
        if (params.get(key) == '1') {
          setAuthToken(getParam('token'));
          setSource('inApp');
          window.location.replace(`${redi_url}/personalInfo`);
          return '';
        }
        if (params.get(key) == '2') {
          setAuthToken(getParam('token'));
          setSource('inApp');
          window.location.replace(`${redi_url}/connectBank`);
          return '';
        }
        if (params.get(key) == '3' || params.get(key) == '4') {
          setAuthToken(getParam('token'));
          setSource('inApp');
          window.location.replace(`${redi_url}/lenderAgreement`);
          return '';
        }
        if (params.get(key) == '5') {
          setAuthToken(getParam('token'));
          setSource('inApp');
          window.location.replace(`${redi_url}/dashboard`);
          return '';
        }
      }
      return params.get(key);
    }
    return '';
  };
  useEffect(() => {
    // setAuthToken(getParam('token'));
    getParam('landing_page');
  }, []);
  return (
    <>
      <Router>
        <ScrollToTop />
        <Switch>
          <Route path='/login'>
            <Login />
          </Route>
          {(window.location.host.split('.')[0] === 'stashearn' ||
            window.location.host.split('.')[0] === 'devp2p'
            ||window.location.host.split(':')[0] === 'localhost'
          ) && (
              <Route path='/' component={P2PRoutes} />
            )}
          <PrivateRoute
            exact
            path='/dashboard'
            component={Dashboard}
            redirectTo='/'
          />
          <PrivateRoute
            exact
            path='/completed-leads'
            component={Complete}
            redirectTo='/'
          />
          <PrivateRoute
            exact
            path='/rejected-leads'
            component={Rejected}
            redirectTo='/'
          />
          <PrivateRoute
            exact
            path='/pending-leads'
            component={Pending}
            redirectTo='/'
          />
          <PrivateRoute
            exact
            path='/received-leads'
            component={Received}
            redirectTo='/'
          />
          <PrivateRoute
            exact
            path='/register'
            component={Registration}
            redirectTo='/'
          />
          <PrivateRoute
            exact
            path='/product-details'
            component={ProductDetails}
            redirectTo='/'
          />
          <PrivateRoute
            exact
            path='/pending'
            component={PendingStatus}
            redirectTo='/'
          />
          <PrivateRoute
            exact
            path='/reject'
            component={Reject}
            redirectTo='/'
          />
          <PrivateRoute
            exact
            path='/offers'
            component={AvailableOffers}
            redirectTo='/'
          />
          <PrivateRoute
            exact
            path='/check-eligibility'
            component={CheckEligibility}
            redirectTo='/'
          />
          <PrivateRoute exact path='/' component={SorryPage} redirectTo='/' />
          <PrivateRoute
            exact
            path='/success'
            component={SucessPage}
            redirectTo='/'
          />
          <PrivateRoute
            exact
            path='/congratulation'
            component={Congratulations}
            redirectTo='/'
          />
          <PrivateRoute
            exact
            path='/scanner'
            component={QrScanner}
            redirectTo='/'
          />

          <PrivateRoute
            exact
            path='/downpayment'
            component={DownPayment}
            redirectTo='/'
          />

          <PrivateRoute
            exact
            path='/imei-number'
            component={ImeiScreenCard}
            redirectTo='/'
          />

          <PrivateRoute
            exact
            path='/offer-summery'
            component={OfferSummery}
            redirectTo='/'
          />
        </Switch>
      </Router>
    </>
  );
}
